import { FavoritesAssignWidgetContainer } from '@cian/favorites-assign-widget';

import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../../actions/authentication';
import { Dispatch } from '../../common/state';
import { FavoritesFolders } from '../../components/FavoritesFolders';
import { getIsFavoritesFoldersEnabled } from '../../selectors';
import { getOffers } from '../../selectors/offers';
import { getUser } from '../../selectors/user';
import {
  trackCreateFolder,
  trackFolderNameClick,
  trackNotificationChangeFolder,
  trackNotificationSaveToFolder,
  trackSaveToFolder,
} from '../../serp/components/offers/tracking';
import { EAlertType } from '../../types/microfrontends';
import { getPosition } from '../../utils/offer/getPosition';

export function FavoritesFoldersContainer() {
  const dispatch = useDispatch<Dispatch>();
  const offers = useSelector(getOffers);
  const isFeatureEnabled = useSelector(getIsFavoritesFoldersEnabled);
  const { isAuthenticated } = useSelector(getUser);

  const handleSaveToFolder = useCallback(
    (offerId: number) => {
      const position = getPosition(offerId, offers);
      trackNotificationSaveToFolder({ offerId, position });
    },
    [offers],
  );

  const handleChangeFolder = useCallback(
    (offerId: number) => {
      const position = getPosition(offerId, offers);
      trackNotificationChangeFolder({ offerId, position });
    },
    [offers],
  );

  if (!isFeatureEnabled) {
    return null;
  }

  const handleCreate = (name: string, offerId: number) => {
    const position = getPosition(offerId, offers);
    trackCreateFolder({ offerId, position });
  };

  const handleSave = (offerId: number) => {
    const position = getPosition(offerId, offers);
    trackSaveToFolder({ offerId, position });
  };

  const handleClickFolderName = (offerId: number, folderId: number) => {
    const position = getPosition(offerId, offers);
    trackFolderNameClick({ offerId, folderId, position });
  };

  const handleLogin = () => {
    dispatch(requestAuthentication({ alert: EAlertType.Favorites }));
  };

  return (
    <FavoritesFolders>
      <FavoritesAssignWidgetContainer
        disableNotification={true}
        isAuthenticated={isAuthenticated}
        onClickFolderName={handleClickFolderName}
        onCreateFolder={handleCreate}
        onNotificationChangeFolder={handleChangeFolder}
        onNotificationSaveToFolder={handleSaveToFolder}
        onSaveOffer={handleSave}
        onWaitForLogin={handleLogin}
      />
    </FavoritesFolders>
  );
}
